import React from 'react';
import T from 'prop-types';
import cx from 'classnames';


const CheckboxLabel = ({
  children, className = '',
}) => (
  <div className={cx('checkbox-label-container', className)}>
    {children}
  </div>
);

CheckboxLabel.propTypes = {
  children: T.oneOfType([T.string, T.node]),
  className: T.oneOfType([T.string, T.func]),

};
export default CheckboxLabel;
